export default {
  ecotronList: [],
  ecotronCurrent: {},
  ecotronPagination: { page: 1, limit: 10, total: 0, totalPages: 0 }, // ← जोड़ा
  ecotronLoading: false
};
